import { Dialog } from "primereact/dialog";
import { BorPanel } from "./BorPanel";

type BorModalProps = {
  visible: boolean;
  onHide: () => void;
  reportId: string;
};

export const BorModal: React.FC<BorModalProps> = ({
  visible,
  onHide,
  reportId,
}) => {
  return (
    <Dialog
      header="Broker of Record"
      visible={visible}
      onHide={onHide}
      style={{ width: "560px" }}
    >
      <BorPanel reportId={reportId} />
    </Dialog>
  );
};
